const EXPERTMODE_CHECKBOX_SELECTOR: string = '[data-expertmode]';
const EXPERTMODE_FIELD_SELECTOR: string = '.expert-field';

export class Expertmode {

  private $checkbox = $(EXPERTMODE_CHECKBOX_SELECTOR);
  public constructor() {
    this.$checkbox.show();
    const checkboxIndex = this.$checkbox.find('.fancy-checkbox input').data('index') - 1;
    window.checkboxes[checkboxIndex].onChange = () => {
      if (window.checkboxes[checkboxIndex].ui.active) {
        $(EXPERTMODE_FIELD_SELECTOR).show();
      } else {
        $(EXPERTMODE_FIELD_SELECTOR).hide();
      }
    };
  }
}

